<template>
  <transition
    enter-active-class="transform duration-300"
    enter-from-class="opacity-0 translate-y-4"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transform duration-300"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-4"
  >
    <div v-if="isNotAccept" class="cn-cookies">
      <div class="container">
        <div class="cn-cookies__content">
          <div class="cn-cookies__text">
            <UiIconCookie />
            <p>
              We use cookies to ensure performance and improve the quality of
              service. By continuing to use our service, you agree to the use of
              these technologies.
              <UiLink to="/privacy-policy">
                {{ $t('more_detailed') }}
              </UiLink>
            </p>
          </div>
          <UiButton variant="red" @click="accept">Accept</UiButton>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useCookies } from '@vueuse/integrations/useCookies';
import UiLink from '@/components/ui/UiLink';
import UiButton from '@/components/ui/UiButton';
import UiIconCookie from '@/components/ui/icons/UiIconCookie';

const cookies = useCookies(['accept-cookies']);
const isNotAccept = computed(() => !cookies.get('accept-cookies'));

const accept = () => {
  cookies.set('accept-cookies', true);
};
</script>
<style lang="scss">
.cn-cookies {
  --ab-canyon-cookies-color-bg: var(--ab-canyon-color-light);
  --ab-canyon-cookies-color-text: var(--ab-canyon-color-dark);
  --ab-canyon-cookies-color-shadow: var(--ab-canyon-color-dark);
  --ab-canyon-cookies-links-color-text: var(--ab-canyon-color-accent);

  color: var(--ab-canyon-cookies-color-text);
  background-color: var(--ab-canyon-cookies-color-bg);
  box-shadow:
    rgba(0, 0, 0, 0) 0px 0px 0px 0px,
    rgba(0, 0, 0, 0) 0px 0px 0px 0px,
    var(--ab-canyon-cookies-color-shadow) 0px 10px 15px -3px,
    var(--ab-canyon-cookies-color-shadow) 0px 4px 6px -4px;
  padding-top: var(--size-3xl);
  padding-bottom: var(--size-3xl);
  z-index: 10;
  right: 0px;
  left: 0px;
  bottom: 0px;
  position: fixed;

  &__content {
    gap: var(--size-base);
    align-items: center;
    flex-direction: column;
    max-width: 830px;
    display: flex;
    margin-left: auto;
    margin-right: auto;
    @media (min-width: 656px) {
      flex-direction: row;
    }
  }
  &__text {
    column-gap: var(--size-base);
    align-items: center;
    display: flex;
    svg {
      flex-shrink: 0;
      width: var(--size-4xl);
      height: var(--size-4xl);
    }
    a {
      color: var(--ab-canyon-cookies-links-color-text);
    }
  }
}
</style>
